import { ISize2 } from "@base/math/Size2";

const palette = {
  background_grey: "#ecedf1",
  subMenuBar_grey: "#dcdfe2",
  buttonBackground_grey: "#788489",
  textColor_grey: "#364045",
  grey: "#778188",
  lightGrey: "#A1A8AD",
  orange: "#fa6a18",
  green: "#89be33",
  red: "#ff0000",
  rainDrop: "#4dbffc",
  white: "#ffffff"
}

export const ShopSkin = {
  palette,
  topBar: {
    height: 70,
    backgroundColor: palette.background_grey,
    menuButton: {
      backgroundColor: "#394348"
    }
  },
  rightBar: {
    width: "500px",
    backgroundColor: palette.background_grey,
  },
  bottomBar: {
    height: "65px"
  },
  view: {
    backgroundColor: palette.background_grey,
  },
  selection: {
    backgroundColor: palette.background_grey,
    systemColor: palette.lightGrey,
    labelColor: palette.textColor_grey
  },
  rightOverlay: {
    backgroundColor: "#ffffff",
    textColor: palette.textColor_grey
  },
  infoOverlay: {
    backgroundColor: "#ffffff",
    textColor: palette.textColor_grey
  },
  configOverlay: {
    backgroundColor: palette.background_grey,
    textColor: palette.textColor_grey
  },
  mainMenu: {
    width: 300,
    backgroundColor: palette.background_grey
  },
  getMode: (size: ISize2): "desktop" | "mobile" => {
    if (size.w >= 800 || size.h >= 800)
      return "desktop";
    return "mobile";
  },
  getOrientation: (size: ISize2): "landscape" | "portrait" => {
    // if (size.w >= 800)
    //   return "desktop";
    return size.w >= size.h ? "landscape" : "portrait";
  }
}
